//Book on YouTube:
const Travel = "vJypsI0EANo";
const Sharvil = "2yEPCBpD5vU";

const DataPages = {
  pages: [
    {
      number: 40,
      name: "Jungle",
      type: "page",
      label: "new",
      video: Sharvil,
      video_time: "34s"
    },
    {
      number: 39,
      name: "Ladybug",
      descr: "",
      type: "page",
      label: "new",
      video: Sharvil,
      video_time: "8s"
    },
    {
      number: 38,
      name: "Palette",
      descr: "",
      type: "page",
      label: "new",
      video: Sharvil,
      video_time: "1m28s"
    },
    {
      number: 37,
      name: "Room",
      descr: "",
      type: "page",
      video: Travel,
      video_time: "9s"
    },
    {
      number: 36,
      name: "Poles",
      descr: "",
      type: "page",
      video: Travel,
      video_time: "1m"
    },
    {
      number: 35,
      name: "Netherlands",
      descr: "",
      type: "page",
      video: Travel,
      video_time: "21s"
    },
    {
      number: 34,
      name: "Stockholm",
      descr: "",
      type: "page",
      video: Travel,
      video_time: "1m29s"
    },
    {
      number: 33,
      name: "Bremen",
      descr: "",
      type: "page",
      video: Travel,
      video_time: "1m13s"
    },
    {
      number: 32,
      name: "Egypt",
      descr: "",
      type: "page",
      video: Travel,
      video_time: "45s"
    },
    {
      number: 31,
      name: "Camelopard",
      type: "page"
    },
    {
      number: 30,
      name: "Road",
      descr: "It is so important to know about the traffic lights, that is why this page is so important. The car  moves and stopes to be refueled by gasoline.",
      type: "page"
    },
    {
      number: 29,
      name: "Boots",
      descr: "You can start learning to tie shoelaces just like grownups do it! The laces are different in shape and color to develop fine motor skills.",
      type: "page"
    },
    // {
    //   number: 28,
    //   name: "Octopus",
    //   descr: "Page for children over 3 years old. They can start learning numbers and to count. Different shapes of beads influence positive to fine motor skills.",
    //   type: "page"
    // },
    {
      number: 28,
      name: "Car",
      descr: "Check if your car is ready to a long trip. Is your accumulator in a good condition? Plus connected  to plus and mines to mines? Don't forget to check the oil in the engine and add more if its needed. Ready to drive? Enjoy!",
      type: "page"
    },
    {
      number: 27,
      name: "Ocean",
      descr: "Bright page that will teach you the sea and undersea transport and different kinds of fish. The ship and a submarine are moving.",
      type: "page"
    },
    {
      number: 26,
      name: "Tractor",
      descr: "NFun page with a lot of farm animals that you can name, count and take with you into a trip. The big tractor wheel is removable.",
      type: "page"
    },
    {
      number: 25,
      name: "Jurassic",
      type: "page"
    },
    {
      number: 24,
      name: "Minion",
      type: "page"
    },
    {
      number: 23,
      name: "Winnie",
      type: "page"
    },
    {
      number: 22,
      name: "Squirrel",
      type: "page"
    },
    {
      number: 21,
      name: "Dogy_2",
      type: "page"
    },
    {
      number: 20,
      name: "Whale",
      type: "page"
    },
    {
      number: 19,
      name: "Croco",
      type: "page"
    },
    {
      number: 18,
      name: "Space",
      type: "page"
    },
    {
      number: 17,
      name: "Leon",
      type: "page"
    },
    {
      number: 16,
      name: "Monster",
      type: "page"
    },
    {
      number: 15,
      name: "Butterfly",
      type: "page"
    },
    {
      number: 14,
      name: "Hair",
      type: "page"
    },
    {
      number: 13,
      name: "Clock",
      type: "page"
    },
    {
      number: 12,
      name: "Match",
      type: "page"
    },
    {
      number: 11,
      name: "Icecream",
      type: "page"
    },
    {
      number: 10,
      name: "Hippo",
      type: "page"
    },
    {
      number: 9,
      name: "Dogy_1",
      type: "page"
    },
    {
      number: 8,
      name: "Crane",
      type: "page"
    },
    {
      number: 7,
      name: "Washer",
      type: "page"
    },
    {
      number: 6,
      name: "Bee",
      type: "page",
      video: Sharvil,
      video_time: "19s"
    },
    {
      number: 5,
      name: "Night",
      type: "page",
      video: Sharvil,
      video_time: "1m18s"
    },
    {
      number: 4,
      name: "Sheep",
      type: "page"
    },
    {
      number: 3,
      name: "Snail",
      type: "page"
    },
    {
      number: 2,
      name: "Chick",
      type: "page"
    },
    {
      number: 1,
      name: "Day",
      descr: "",
      type: "page"
    }
  ],
  all: function() { return this.pages },
  get: function(id) {
    const isPage = p => p.number === id
    return this.pages.find(isPage)
  }
}

export default DataPages



// WEBPACK FOOTER //
// ./src/components/API_Pages.js